import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { useTotalData } from "hooks/api";
import { LOCAL_STORAGE_KEYS } from "consts";
import { CustomAccordion } from "../components";
import { TotalChart, ScopeChart, RenewableNonRenewableChart, UtilityTypeChart, BusinessUnitChart, SiteTypeChart, RegionChart, CountryChart, SiteChart, EstimatesChart } from "../../charts";
import { DropdownProps } from "../types";

const DateRangeDropdown = ({ searchFilters, subTypeChart, currentMainTab }: DropdownProps) => {
  const currentDate = dayjs.utc();

  const storedDateRangeStartDate = localStorage.getItem(LOCAL_STORAGE_KEYS.DASHBOARD_PAGE_DATE_RANGE_START_DATE);
  const storedDateRangeEndDate = localStorage.getItem(LOCAL_STORAGE_KEYS.DASHBOARD_PAGE_DATE_RANGE_END_DATE);

  const isValidDateRangeStartDate = storedDateRangeStartDate && storedDateRangeStartDate !== "";
  const isValidDateRangeEndDate = storedDateRangeEndDate && storedDateRangeEndDate !== "";

  const [dateRangeStartDate, setDateRangeStartDate] = useState<Dayjs>(isValidDateRangeStartDate ? dayjs(storedDateRangeStartDate) : dayjs(currentDate.date(1)).subtract(2, "month"));
  const [dateRangeEndDate, setDateRangeEndDate] = useState<Dayjs>(isValidDateRangeEndDate ? dayjs(storedDateRangeEndDate) : dayjs(currentDate));
  const [dateRangeType, setDateRangeType] = useState<string>("MONTHLY");
  const [isExpanded, setIsExpanded] = useState(false);

  const { totalData, isLoadingTotal } = useTotalData({
    searchFilters,
    dateRangeStartDate,
    dateRangeEndDate,
    dateRangeType,
    currentMainTab,
    subTypeChart,
    enabled: isExpanded,
  });

  return (
    <CustomAccordion
      titleAccordion="Date Range"
      dateRangeType={dateRangeType}
      setDateRangeType={setDateRangeType}
      startDate={dateRangeStartDate}
      endDate={dateRangeEndDate}
      setStartDate={setDateRangeStartDate}
      setEndDate={setDateRangeEndDate}
      panelNumber={2}
      allowPeriods
      onExpandedChange={setIsExpanded}
    >
      <TotalChart
        chartTitle="Total"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <ScopeChart
        chartTitle="Scope"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      {(currentMainTab === "Consumption" || currentMainTab === "Financials")
        && <RenewableNonRenewableChart
          chartTitle="Renewable vs. Non-Renewable"
          subTabName={subTypeChart}
          dateRangeType={dateRangeType}
          currentMainTab={currentMainTab}
          startDate={dateRangeStartDate}
          endDate={dateRangeEndDate}
          searchFilters={searchFilters}
          sharedTotalData={totalData}
          isLoadingTotal={isLoadingTotal}
        />}
      <UtilityTypeChart
        chartTitle="Utility Type"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <BusinessUnitChart
        chartTitle="Business Unit"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <SiteTypeChart
        chartTitle="Site Type"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <RegionChart
        chartTitle="Region"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <CountryChart
        chartTitle="Country"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <SiteChart
        chartTitle="Site"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
      <EstimatesChart
        chartTitle="Estimates"
        subTabName={subTypeChart}
        dateRangeType={dateRangeType}
        currentMainTab={currentMainTab}
        startDate={dateRangeStartDate}
        endDate={dateRangeEndDate}
        searchFilters={searchFilters}
        sharedTotalData={totalData}
        isLoadingTotal={isLoadingTotal}
      />
    </CustomAccordion>
  );
}

export default DateRangeDropdown;